import ChatIcon from '@mui/icons-material/Chat';
import ChatList from './ChatList';

export default {
    list: ChatList,
    icon: ChatIcon,
    recordRepresentation: (record: any) => `Chat ${record.pid}-${record.aid}`,
};
